<template>
	<div>
		<a-page-header style="background: #fff;" title="会员详情" />
		<a-row>
			<a-col :span="24">
				<div class="mainBox">
					<div class="contentBox" v-if="detail">
						<a-row>
							<a-col :span="8">
								<div style="text-align: center;padding: 50px;">
									<a-avatar :size="100" icon="user" :src="detail.wxInfo.headpic" />
									<div style="font-size: 24px;font-weight: 700;margin-top: 10px;">{{detail.wxInfo.nickname}}
										<a-icon type="man" style="color:#597ef7 ;" v-if="detail.wxInfo.sex == 1" />
										<a-icon style="color:#f759ab ;" type="woman" v-if="detail.wxInfo.sex == 2" />
									</div>
								</div>
							</a-col>
							<a-col :span="16">
								<a-page-header :ghost="false" :subTitle="'ID ' + detail.id">
									<a-descriptions size="small" :column="1">
										<a-descriptions-item label="姓名"><strong>{{detail.memberName}}</strong></a-descriptions-item>
										<a-descriptions-item label="电话"><strong>{{detail.memberPhone}}</strong></a-descriptions-item>
										<a-descriptions-item label="会员等级">
											<a-tag color="blue">{{detail.levelInfo.levelName}}</a-tag>
										</a-descriptions-item>
										<a-descriptions-item label="累计消费"><strong>{{detail.memberPayMoney}} 元</strong> <a style="margin-left: 10px;" @click="toOrderList">消费记录</a></a-descriptions-item>
										<a-descriptions-item label="累计积分"><strong>{{detail.memberIntegral}} 积分</strong></a-descriptions-item>
										<a-descriptions-item label="钱包余额"><strong>{{detail.memberMoney}} 元</strong> <a style="margin-left: 10px;" @click="toRechargeList">充值记录</a></a-descriptions-item>
										<a-descriptions-item label="添加时间">{{detail.addTime}}</a-descriptions-item>
									</a-descriptions>
								</a-page-header>
							</a-col>
						</a-row>
					</div>
				</div>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				detail: {},
			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.getDetail()
		},
		methods: {
			toOrderList(){
				this.$router.push('/order/OrderList?memberId=' + this.id)
			},
			
			toRechargeList(){
				this.$router.push('/recharge/rechargeList?wx=' + this.detail.wx)
			},
				
			getDetail() {
				this.$http.post('/admin/index.php/admin/User/memberInfo', {
					id: this.id,
				}).then(res => {
					if (res.data.code == 1) {
						this.detail = res.data.data
					}
				})
			},
		},
	}
</script>

<style scoped="">
	.classTitle {
		padding: 20px;
		text-align: center;
		font-size: 20px;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}

	.events {
		list-style: none;
		margin: 0;
		padding: 0;
	}

	.events .ant-badge-status {
		overflow: hidden;
		white-space: nowrap;
		width: 100%;
		text-overflow: ellipsis;
		font-size: 12px;
	}

	.notes-month {
		text-align: center;
		font-size: 28px;
	}

	.notes-month section {
		font-size: 28px;
	}

	/deep/ .ant-fullcalendar-header .ant-radio-group {
		display: none
	}

	/* For demo */
	.ant-carousel>>>.slick-slide {
		text-align: center;
		height: 160px;
		line-height: 160px;
		background: #364d79;
		overflow: hidden;
	}

	.ant-carousel>>>.custom-slick-arrow {
		width: 25px;
		height: 25px;
		font-size: 25px;
		color: #fff;
		background-color: rgba(31, 45, 61, 0.11);
		opacity: 0.3;
	}

	.ant-carousel>>>.custom-slick-arrow:before {
		display: none;
	}

	.ant-carousel>>>.custom-slick-arrow:hover {
		opacity: 0.5;
	}

	.ant-carousel>>>.slick-slide h3 {
		color: #fff;
	}
</style>
